import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./listbox.script";
export function RuiListboxOption({
  value,
  label,
  children,
  class: className,
  disabled,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-listbox__option", className),
    role: "option",
    "data-value": value,
    "data-label": label,
    "aria-disabled": disabled ? "true" : void 0,
    tabindex: -1,
    children
  });
}
function listboxIsBordered(embedded, bordered) {
  if (bordered != null) {
    return bordered;
  }
  return !embedded;
}
function ListboxShell({
  bordered,
  children,
  disabled,
  label
}) {
  return /* @__PURE__ */jsx("div", {
    class: cx("rui-listbox", bordered && "rui-listbox--bordered"),
    role: "listbox",
    "data-rui-control": true,
    "data-rui-control-type": "text",
    "aria-label": label || void 0,
    "aria-disabled": disabled ? "true" : void 0,
    children
  });
}
export function RuiListbox({
  options,
  children,
  embedded,
  bordered,
  label,
  disabled,
  ...props
}) {
  const isBordered = listboxIsBordered(embedded, bordered);
  if (options != null) {
    return /* @__PURE__ */jsx("rui-listbox", {
      ...props,
      embedded,
      bordered,
      label,
      disabled,
      children: /* @__PURE__ */jsx(ListboxShell, {
        bordered: isBordered,
        disabled,
        label,
        children: options.map(option => /* @__PURE__ */jsx(RuiListboxOption, {
          value: option.value,
          label: typeof option.label === "string" ? option.label : void 0,
          disabled: option.disabled,
          children: option.label
        }))
      })
    });
  }
  return /* @__PURE__ */jsx("rui-listbox", {
    ...props,
    embedded,
    bordered,
    label,
    disabled,
    children: /* @__PURE__ */jsx(ListboxShell, {
      bordered: isBordered,
      disabled,
      label,
      children
    })
  });
}